import { APICfg } from 'services/api/api'
import { APIDrink } from '../drink/types/api/response-models'
import { ProductSection, ProductSectionToAPI } from '../types'
import { productSectionParse } from '../utils'

export type DrinkSpecialType =
  | 'alcoholicCocktail'
  | 'analcoholicCocktail'
  | 'beer'
  | 'wine'
  | 'softDrink'

export type DrinkSection = ProductSection<APIDrink> & {
  specialType?: DrinkSpecialType
}

type DrinkSectionToAPI = ProductSectionToAPI

const apiCfg: APICfg = {
  endpoint: 'drinksections',
  parse: productSectionParse,
  write: async (req: DrinkSection): Promise<DrinkSectionToAPI> => req,
}

export default apiCfg
